<template>
    <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="Payout" force-render>
            <a-table rowKey="id" :data-source="capt_xu_payouts" :columns="payout_columns">
                <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                    style="padding: 8px">
                    <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                        :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                        @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                        @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                        Search
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                        Reset
                    </a-button>
                </div>
                <a-icon slot="filterIcon" slot-scope="filtered" type="search"
                    :style="{ color: filtered ? '#108ee9' : undefined }" />
                <template slot="customRender" slot-scope="text, record, index, column">
                    <span v-if="searchText && searchedColumn === column.dataIndex">
                        <template v-for="(fragment, i) in text
                            .toString()
                            .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                            <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()" :key="i"
                                class="highlight">{{ fragment }}</mark>
                            <template v-else>{{ fragment }}</template>
                        </template>
                    </span>
                    <template v-else>
                        {{ text }}
                    </template>
                </template>
                <template slot="payout_counter" slot-scope="text, record">
                    <span style="color: green;font-weight: bold;">
                        Y
                    </span>:{{capt_xu_payouts.filter(p => p.capt_xu_vsl_id ===
                        record.id).filter(p => !p.is_paid).length}}
                    /<span style="color: red;font-weight: bold;">
                        N
                    </span>:{{capt_xu_payouts.filter(p => p.capt_xu_vsl_id ===
                        record.id).filter(p => p.is_paid).length}}
                </template>

                <template slot="is_paid" slot-scope="text, record">
                    <span v-if="record.is_paid" style="font-weight: bold; color: green;">Y</span>
                    <span v-else style="font-weight: bold; color: red;">N</span>
                </template>
                <template slot="action" slot-scope="text, record">
                    <div class="editable-row-operations" style="text-align: center">
                        <a-upload name="file" @change="(info) => change_upload(record, info)" :showUploadList="false"
                            :fileList="record.attachments" :action="$store.state.base_url + '/upload'"
                            :headers="headers">
                            <a-button type="link">Upload Bank Slip</a-button>
                        </a-upload>

                        <a-popconfirm title="Are you sure Reset to Unpaid?" @confirm="reset_paid(record.id)"
                            okText="Yes" cancelText="No">
                            <a href="#">Reset to Unpaid</a>
                        </a-popconfirm>
                    </div>
                </template>
            </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="Income" force-render>
            <a-table rowKey="id" :data-source="capt_xu_payouts" :columns="payout_columns">
                <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                    style="padding: 8px">
                    <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                        :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                        @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                        @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                        Search
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                        Reset
                    </a-button>
                </div>
                <a-icon slot="filterIcon" slot-scope="filtered" type="search"
                    :style="{ color: filtered ? '#108ee9' : undefined }" />
                <template slot="customRender" slot-scope="text, record, index, column">
                    <span v-if="searchText && searchedColumn === column.dataIndex">
                        <template v-for="(fragment, i) in text
                            .toString()
                            .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                            <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()" :key="i"
                                class="highlight">{{ fragment }}</mark>
                            <template v-else>{{ fragment }}</template>
                        </template>
                    </span>
                    <template v-else>
                        {{ text }}
                    </template>
                </template>
                <template slot="payout_counter" slot-scope="text, record">
                    <span style="color: green;font-weight: bold;">
                        Y
                    </span>:{{capt_xu_payouts.filter(p => p.capt_xu_vsl_id ===
                        record.id).filter(p => !p.is_paid).length}}
                    /<span style="color: red;font-weight: bold;">
                        N
                    </span>:{{capt_xu_payouts.filter(p => p.capt_xu_vsl_id ===
                        record.id).filter(p => p.is_paid).length}}
                </template>

                <template slot="is_paid" slot-scope="text, record">
                    <span v-if="record.is_paid" style="font-weight: bold; color: green;">Y</span>
                    <span v-else style="font-weight: bold; color: red;">N</span>
                </template>
                <template slot="action" slot-scope="text, record">
                    <div class="editable-row-operations" style="text-align: center">
                        <a-upload name="file" @change="(info) => change_upload(record, info)" :showUploadList="false"
                            :fileList="record.attachments" :action="$store.state.base_url + '/upload'"
                            :headers="headers">
                            <a-button type="link">Upload Bank Slip</a-button>
                        </a-upload>

                        <a-popconfirm title="Are you sure Reset to Unpaid?" @confirm="reset_paid(record.id)"
                            okText="Yes" cancelText="No">
                            <a href="#">Reset to Unpaid</a>
                        </a-popconfirm>
                    </div>
                </template>
            </a-table>
        </a-tab-pane>


    </a-tabs>
</template>


<script>
import userinfo from "../../utils/userinfo.js";

const capt_xu_vessel_data = [
    {
        id: 1,
        cpdate: "2016-02-12",
        creator: null,
        vessel_name: "OCEAN GEM1ss"
    },
    {
        id: 2,
        cpdate: "2016-02-12",
        creator: null,
        vessel_name: "OCEAN GEM2aa"
    },
    {
        id: 3,
        cpdate: "2016-02-12",
        creator: null,
        vessel_name: "OCEAN GEM3ssss"
    },
    {
        id: 4,
        cpdate: "2016-02-12",
        creator: null,
        vessel_name: "OCEAN GEM4dddd"
    },
];
const capt_xu_payouts = [
    {
        id: 1,
        capt_xu_vsl_id: 1,
        date: "2016-02-12",
        item_name: "item1",
        beneficiary: "beneficiary1",
        amount: 1000,
        remarks: "remarks1",
        is_paid: false,
    },
    {
        id: 2,
        capt_xu_vsl_id: 1,
        date: "2016-02-12",
        item_name: "item2",
        beneficiary: "beneficiary1",
        amount: 1000,
        remarks: "remarks1",
        is_paid: true,
    }
];


export default {
    name: "capt_xu_vsl_mgt_cost",
    data() {
        return {
            capt_xu_vessel_data: capt_xu_vessel_data,
            capt_xu_payouts: capt_xu_payouts,
            headers: {
                access_token: userinfo.get().access_token,
            },

            userinfo: userinfo.get(),

            searchText: '',
            searchInput: null,
            searchedColumn: '',

            payout_edit_visible: false,
            income_edit_visible: false,

            payout_columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                    align: 'center',
                },
                {
                    title: 'Date',
                    dataIndex: 'date',
                    key: 'date',
                    align: 'center',
                },
                {
                    title: 'Item Name',
                    dataIndex: 'item_name',
                    key: 'item_name',
                    align: 'center',
                },
                {
                    title: 'Beneficiary',
                    dataIndex: 'beneficiary',
                    key: 'beneficiary',
                    align: 'center',
                },
                {
                    title: 'Amount',
                    dataIndex: 'amount',
                    key: 'amount',
                    align: 'center',
                },
                {
                    title: 'Remarks',
                    dataIndex: 'remarks',
                    key: 'remarks',
                    align: 'center',
                },
                {
                    title: 'Is Paid',
                    dataIndex: 'is_paid',
                    key: 'is_paid',
                    align: 'center',
                    scopedSlots: { customRender: "is_paid" },
                },
                {
                    title: 'Actions',
                    dataIndex: 'actions',
                    key: 'actions',
                    align: 'center',
                    scopedSlots: { customRender: "action" },
                }
            ],

        };
    },
    methods: {
        handleSearch(selectedKeys, confirm, dataIndex) {
            confirm();
            this.searchText = selectedKeys[0];
            this.searchedColumn = dataIndex;
        },
        handleReset(clearFilters) {
            clearFilters();
            this.searchText = '';
        },
    },

    mounted() {

    },
    watch: {

    },
};

</script>